import RequestHandler from "./RequestHandler";

function LicensePlansAPI() {
    const baseLicensePlansAPI = "license-plans";

    async function getLicensePlans() {
        try {
            const result = await RequestHandler.get(`${baseLicensePlansAPI}`);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getLicensePlans,
    };
}

export default LicensePlansAPI();
